/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TripProgramDto } from '../../models/trip-program-dto';

export interface PostTripProgramCreate$Params {
  trip: string;
      body: TripProgramDto
}

export function postTripProgramCreate(http: HttpClient, rootUrl: string, params: PostTripProgramCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postTripProgramCreate.PATH, 'post');
  if (params) {
    rb.path('trip', params.trip, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postTripProgramCreate.PATH = '/v1/camp-trip/{trip}/program';
